import { defineStore } from "pinia";
import { GalaxyApi } from "@/api";
import { errorMessageAsString } from "@/utils/simple-error";
import { canUpgrade, findTemplate, getLatestVersion, getLatestVersionMap } from "./configTemplatesUtil";
export const useFileSourceTemplatesStore = defineStore("fileSourceTemplatesStore", {
    state: () => ({
        templates: [],
        fetched: false,
        error: null,
    }),
    getters: {
        latestTemplates: (state) => {
            // only expose latest instance by template_version for each template_id
            const latestVersions = getLatestVersionMap(state.templates);
            return state.templates.filter((i) => latestVersions[i.id] == (i.version || 0));
        },
        canUpgrade: (state) => {
            return (templateId, templateVersion) => canUpgrade(state.templates, templateId, templateVersion);
        },
        getTemplates: (state) => {
            return state.templates;
        },
        getTemplate: (state) => {
            return (templateId, templateVersion) => findTemplate(state.templates, templateId, templateVersion);
        },
        getLatestTemplate: (state) => {
            return (templateId) => getLatestVersion(state.templates, templateId);
        },
        hasTemplates: (state) => {
            return state.templates.length > 0;
        },
        loading: (state) => {
            return !state.fetched;
        },
    },
    actions: {
        async handleInit(templates) {
            this.templates = templates;
            this.fetched = true;
        },
        async handleError(err) {
            this.fetched = true;
            this.error = errorMessageAsString(err);
        },
        async fetchTemplates() {
            const { data: templates, error } = await GalaxyApi().GET("/api/file_source_templates");
            if (error) {
                this.handleError(error);
                return;
            }
            this.handleInit(templates);
        },
        async ensureTemplates() {
            if (!this.fetched || this.error != null) {
                await this.fetchTemplates();
            }
        },
    },
});
